module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0757.493c386c.jpg";